import React from "react";
import { Box, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import documentIcon from "../../../assets/images/icons/documentsGridIcon.svg";
import { documentsCellStyle } from "../style";
import { useNavigate } from "react-router-dom";

interface DocumentsCellRendererProps {
  value: string;
  tripId:number
}

const DocumentsCellRenderer: React.FC<DocumentsCellRendererProps> = ({
  value,
  tripId
}) => {
  const navigate = useNavigate();
  
  return (
    <Box style={documentsCellStyle.wrapper}>
      <IconButton onClick={() => navigate(`/tripdetails/${tripId}/documents`)} color="primary" size="small">
        <img
          src={documentIcon}
          alt="Document Icon"
          style={documentsCellStyle.img}
        />
      </IconButton>
    </Box>
  );
};

export default DocumentsCellRenderer;
